import {Checkbox, FormControlLabel} from "@mui/material";
import Alert from "@mui/material/Alert";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";

import Cookies from "js-cookie";
import React from "react";

import {useNavigate, useParams} from "react-router-dom";
import {CASH_ACTIVITY_TYPES} from "../../constants";

import {cashRegisterUpdate, getCashById} from "../../services/requests/GraphRequests";
import RU from "../../services/translation/ru.json";
import {translation} from "../../services/translation/translation";
import {validateCashRegister} from "../../services/Validations";

export default function EditCashRegister() {
	let navigate = useNavigate();
	let params = useParams();

	const {cashRegisterId = "", companyId = ""} = params || {};

	const [loading, setLoading] = React.useState(true);
	const [cashRegister, setCashRegister] = React.useState({});
	const [companyWithCash, setCompanyWithCash] = React.useState({});
	const [dict, setDict] = React.useState(RU);

	const [formValidationError, setFormValidationError] = React.useState({
		address: false,
		number: false,
		key: false,
		subdivision: false,
		point: false,
	});

	React.useEffect(() => {
		getCashById(companyId, cashRegisterId).then((data) => {
			const organization = data.data.organization;
			const filteredCashRegisters = organization.cashRegisters.filter(
				(cashRegister) => cashRegister.id === parseInt(cashRegisterId)
			);
			setCompanyWithCash(organization);
			setCashRegister(filteredCashRegisters?.[0]);
			setLoading(false);
		});
		if (Cookies.get("simpalsid.lang")) {
			setDict(translation(Cookies.get("simpalsid.lang")));
		} else {
			setDict(translation("ru"));
		}
	}, [cashRegisterId, companyId]);

	let [readyToSave, setReadyToSave] = React.useState(false);
	let [thereAreChanges, setThereAreChanges] = React.useState(false);

	const [openSuccess, setOpenSuccess] = React.useState(false);
	const [error, setError] = React.useState({
		status: false,
		msg: "Error",
	});

	React.useEffect(() => {
		if (thereAreChanges) {
			let validateResult = validateCashRegister(cashRegister);
			setReadyToSave(validateResult.validation);
			setFormValidationError(validateResult.errors);
		}
	}, [cashRegister, thereAreChanges]);

	React.useEffect(() => {
		if (openSuccess) {
			setTimeout(function () {
				navigate(
					`/cash-register/${params.companyId}/${cashRegister.id}`
				);
			}, 1500);
		}
	}, [
		cashRegister.id,
		navigate,
		openSuccess,
		params.companyId,
		setOpenSuccess,
	]);

	const handleChange = (event) => {
		const value =
			event.target.type === "checkbox"
				? event.target.checked
				: event.target.value;

		setCashRegister({
			...cashRegister,
			[event.target.name]: value,
		});
		setThereAreChanges(true);
	};

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setOpenSuccess(false);
		setError({
			status: false,
			msg: "Error",
		});
	};

	function saveCashRegister() {
		cashRegisterUpdate(cashRegister, companyId).then((data) => {
			if (data.data.data?.updateCashRegister?.id) {
				navigate(
					`/cash-register/${params.companyId}/${cashRegister.id}`
				);
			} else {
				let msgError = "There are errors while receipt generation";
				if (data.data.errors.length > 0) {
					msgError = data.data.errors[0].message;
				}
				setError({
					status: true,
					msg: msgError,
				});
			}
		});
	}

	if (loading) {
		return (
			<div align="center">
				<CircularProgress/>
			</div>
		);
	}

	return (
		<Box
			sx={{flexGrow: 1, marginTop: 3, marginLeft: 10, marginBottom: 10}}
		>
			<Grid container sx={{marginTop: 2}} spacing={4} align="left">
				<Grid item xs={6}>
					<Typography
						sx={{fontSize: 24}}
						color="pimary"
						gutterBottom
					>
						{dict.edit} eKassa № {cashRegister.id}
					</Typography>
					<Button
						variant="text"
						color="secondary"
						onClick={() => {
							navigate(
								`/cash-register/${params.companyId}/${cashRegister.id}`
							);
						}}
					>
						&#60; {dict.go_back}
					</Button>
					{/* Organization info */}
					<Grid container spacing={2} align="left">
						<Grid item xs={4}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{dict.org_name}:
							</Typography>
						</Grid>
						<Grid item xs={8}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{companyWithCash.name}
							</Typography>
						</Grid>
						<Grid item xs={4}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{dict.idno}:
							</Typography>
						</Grid>
						<Grid item xs={8}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{companyWithCash.idno}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={5} align="right">
					<Button
						variant="outlined"
						disabled={!readyToSave}
						onClick={saveCashRegister}
					>
						{dict.save} {' '} eKassa
					</Button>
				</Grid>
			</Grid>
			<Grid container sx={{marginTop: 2}} spacing={4} align="left">
				<Grid item xs={5}>
					<FormControl fullWidth sx={{m: 1}} variant="standard">
						<InputLabel htmlFor="component-simple">
							{dict.address}
						</InputLabel>
						<Input
							id="component-simple"
							value={cashRegister.address}
							onChange={handleChange}
							name="address"
							aria-describedby="standard-helper-text"
							inputProps={{
								"aria-label": "text",
							}}
							error={formValidationError.address}
						/>
						<FormHelperText id="standard-helper-text">
							{dict.must_not_empty}
						</FormHelperText>
					</FormControl>
					<FormControl fullWidth sx={{m: 1}} variant="standard">
						<InputLabel htmlFor="component-simple">
							{dict.point}
						</InputLabel>
						<Input
							id="component-simple"
							value={cashRegister.point}
							onChange={handleChange}
							name="point"
							aria-describedby="standard-helper-text"
							inputProps={{"aria-label": "text"}}
							error={formValidationError.point}
						/>
					</FormControl>
					<FormControl fullWidth sx={{m: 1}} variant="standard">
						<InputLabel htmlFor="component-simple">
							{dict.activity_type}
						</InputLabel>
						<Select
							variant={'standard'}
							value={cashRegister?.activityType}
							onChange={handleChange}
							name="activityType"
							aria-describedby="standard-helper-text"
							inputProps={{"aria-label": "text"}}
							error={formValidationError?.activityType}
						>
							<MenuItem
								value={null}
							>
								-
							</MenuItem>
							{Object.keys(CASH_ACTIVITY_TYPES).map(
								(type, index) => (
									<MenuItem
										key={`${type + index}`}
										value={type}
									>
										{dict?.[`activity_${type.toLocaleLowerCase()}`]}
									</MenuItem>
								)
							)}
						</Select>
					</FormControl>
					<FormControl fullWidth sx={{m: 1}} variant="standard">
						<FormControlLabel
							control={<Checkbox/>}
							label="Disabled"
							checked={cashRegister.deleted}
							name="deleted"
							onChange={handleChange}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<FormControl fullWidth sx={{m: 1}} variant="standard">
						<InputLabel htmlFor="component-simple">
							{dict.registration_number}
						</InputLabel>
						<Input
							id="component-simple"
							value={cashRegister.number}
							onChange={handleChange}
							name="number"
							aria-describedby="standard-helper-text"
							inputProps={{
								"aria-label": "text",
							}}
							error={formValidationError.number}
						/>
						<FormHelperText id="standard-helper-text">
							{dict.must_10_12_char}
						</FormHelperText>
					</FormControl>
					<FormControl fullWidth sx={{m: 1}} variant="standard">
						<InputLabel htmlFor="component-simple">
							{dict.key}
						</InputLabel>
						<Input
							id="component-simple"
							value={cashRegister.key}
							onChange={handleChange}
							name="key"
							aria-describedby="standard-helper-text"
							inputProps={{
								"aria-label": "text",
							}}
							error={formValidationError.key}
						/>
					</FormControl>
					<FormControl fullWidth sx={{m: 1}} variant="standard">
						<InputLabel htmlFor="component-simple">
							{dict.subdivision}
						</InputLabel>
						<Input
							id="component-simple"
							value={cashRegister.subdivision}
							onChange={handleChange}
							name="subdivision"
							aria-describedby="standard-helper-text"
							inputProps={{
								"aria-label": "text",
							}}
							error={formValidationError.subdivision}
						/>
					</FormControl>
				</Grid>
				<Snackbar
					open={openSuccess}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="success"
						sx={{width: "100%"}}
					>
						Cash register saved!
					</Alert>
				</Snackbar>
				<Snackbar
					open={error.status}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="error"
						sx={{width: "100%"}}
					>
						{error.msg}
					</Alert>
				</Snackbar>
			</Grid>
		</Box>
	);
}
